import { render } from "./RegisterStepThree.vue?vue&type=template&id=020643fc"
import script from "./RegisterStepThree.vue?vue&type=script&lang=js"
export * from "./RegisterStepThree.vue?vue&type=script&lang=js"
script.render = render

export default script